import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {app} from './firebase'
import i18n from './i18n'
import 'highlight.js/styles/github-dark-dimmed.css'
import 'highlight.js/lib/common';
import hljsVuePlugin from "@highlightjs/vue-plugin";
import VueGtag from 'vue-gtag';

createApp(App).use(store).use(i18n).use(hljsVuePlugin).use(app).use(router).use(VueGtag, {id: "G-31KR96FGMP" }, router).mount('#app')
